import { createThemeColorsContext } from "./colors-context/colors-context";

export type BackdropsValue = {
  dialog: string;
};

const [UiBackdropsColors, useBackdropsColors] =
  createThemeColorsContext<BackdropsValue>("backdrops");

export { UiBackdropsColors, useBackdropsColors };
